<script setup lang="ts">
defineOptions({
  name: 'DatenschutzComponent'
})
</script>

<template>
  <div class="px-0 py-0 mx-0 my-0">
    <div class="pt-high">
      <v-row align="center">
        <v-col cols="12" lg="12" class="px-8 px-lg-16">
          <h1 class="text-primary bannerTitle font-weight-regular mb-16">Datenschutz</h1>
          <h2 class="text-h2 pb-4 pt-6">I. Name und Anschrift des Verantwortlichen</h2>
          <p class="text-body-1 mb-4">
            Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler
            Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher
            Bestimmungen ist:<br />
            Dipl.-Ing. (FH) Andreas Szklarek<br />
            Hansastraße. 9<br />
            42697 Solingen<br />
            Telefon 0212.68599611<br />
            E-Mail: szklarek@johnsenpartner.de<br />
          </p>
          <h2 class="text-h2 pb-4 pt-6">II. Allgemeines zur Datenverarbeitung</h2>

          <h3 class="text-h5 mb-1">1. Umfang der Verarbeitung personenbezogener Daten</h3>

          <p class="text-body-1 mb-4">
            Wir erheben und verwenden personenbezogene Daten unserer Nutzer grundsätzlich nur,
            soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und
            Leistungen erforderlich ist. Die Erhebung und Verwendung personenbezogener Daten unserer
            Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in
            solchen Fällen, in denen eine vorherige Einholung einer Einwilligung aus tatsächlichen
            Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften
            gestattet ist.
          </p>
          <h3 class="text-h5 mb-1">
            2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten
          </h3>
          <p class="text-body-1 mb-4">
            Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der
            betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung
            (DSGVO) als Rechtsgrundlage. Bei der Verarbeitung von personenbezogenen Daten, die zur
            Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich
            ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für
            Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich
            sind. Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen
            Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1
            lit. c DSGVO als Rechtsgrundlage. Für den Fall, dass lebenswichtige Interessen der
            betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung
            personenbezogener Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als
            Rechtsgrundlage. Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres
            Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen, Grundrechte
            und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6
            Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung.
          </p>

          <h3 class="text-h5 mb-1">3. Datenlöschung und Speicherdauer</h3>
          <p class="text-body-1 mb-4">
            Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald
            der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn
            dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen
            Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche
            unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann,
            wenn eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn,
            dass eine Erforderlichkeit zur weiteren Speicherung der Daten für einen
            Vertragsabschluss oder eine Vertragserfüllung besteht.
          </p>

          <h3 class="text-h5 mb-1">4. Kategorien von Empfängern</h3>
          <p class="text-body-1 mb-4">
            Empfängern der über unsere Internetseite verarbeiteten personenbezogenen Daten ist
            grundsätzlich, soweit nachfolgend nicht anders beschrieben, der Verantwortliche (s.
            Ziffer I dieser Datenschutzerklärung) bzw. diejenigen Stellen im Architekturbüro, die
            diese zur Erfüllung seiner vertraglichen und gesetzlichen Pflichten benötigen. Die Daten
            werden grundsätzlich nicht an Dritte übermittelt. Eine Übermittlung an Dritte erfolgt
            aber unter Wahrung der Vorschriften der DSGVO und des BDSG sowie weiterer, etwaiger
            datenschutzrechtlicher Vorschriften, soweit dies gesetzlich vorgeschrieben ist, jeweils
            im Rahmen der durch das jeweilige Gesetz vorgegebenen Anforderungen und gegebenenfalls
            Abwägungen der betroffenen Interessen. Unter diesen Voraussetzungen können Empfänger
            personenbezogener Daten sein, soweit nicht weitere Empfänger ergänzend unter III ff.
            aufgeführt sind: Auftragsverarbeiter, an die wir zur Durchführung der Geschäftsbeziehung
            mit Ihnen personenbezogene Daten übermitteln (z.B. Hosting-Dienstleister); Diejenigen
            Stellen, für die Sie uns ggf. Ihre Einwilligung zur Datenübermittlung erteilt haben.
          </p>

          <h2 class="text-h2 pb-4 pt-6">
            III. Bereitstellung der Website und Erstellung von Logfiles
          </h2>

          <h3 class="text-h5 mb-1">1. Beschreibung und Umfang der Datenverarbeitung</h3>
          <p class="text-body-1 mb-1">
            Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und
            Informationen vom Computersystem des aufrufenden Rechners. Folgende Daten werden hierbei
            erhoben:
          </p>
          <ul class="text-body-1 mb-4">
            <li>Informationen über den Browsertyp und die verwendete Version</li>
            <li>Das Betriebssystem des Nutzers</li>
            <li>URL, die der Nutzer als letzte besucht hat</li>
            <li>Hostnamen des zugreifenden Rechners</li>
            <li>Die IP-Adresse des Nutzers</li>
            <li>Datum und Uhrzeit des Zugriffs</li>
          </ul>
          <p class="text-body-1 mb-4">
            Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine Speicherung
            dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht
            statt.
          </p>

          <h3 class="text-h5 mb-1">2. Rechtsgrundlage für die Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6
            Abs. 1 lit. f DSGVO.
          </p>

          <h3 class="text-h5 mb-1">3. Zweck der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine
            Auslieferung der Website an den Rechner des Nutzers zu ermöglichen. Hierfür muss die
            IP-Adresse des Nutzers für die Dauer der Sitzung gespeichert bleiben. Die Speicherung in
            Logfiles erfolgt, um die Funktionsfähigkeit der Website sicherzustellen. Zudem dienen
            uns die Daten zur Optimierung der Website und zur Sicherstellung der Sicherheit unserer
            informationstechnischen Systeme. Eine Auswertung der Daten zu Marketingzwecken findet in
            diesem Zusammenhang nicht statt. In diesen Zwecken liegt auch unser berechtigtes
            Interesse an der Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h3 class="text-h5 mb-1">4. Dauer der Speicherung</h3>
          <p class="text-body-1 mb-4">
            Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
            nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der
            Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist. Im Falle der
            Speicherung der Daten in Logfiles ist dies nach spätestens 14 Tagen der Fall, soweit in
            dieser Datenschutzerklärung nicht anders angegeben. Eine darüberhinausgehende
            Speicherung ist möglich. In diesem Fall wird die IP-Adresse der Nutzer gelöscht oder
            verfremdet, sodass eine Zuordnung des aufrufenden Clients nicht mehr möglich ist.
          </p>

          <h3 class="text-h5 mb-1">5. Widerspruchs- und Beseitigungsmöglichkeit</h3>
          <p class="text-body-1 mb-4">
            Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in
            Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht
            folglich seitens des Nutzers keine Widerspruchsmöglichkeit.
          </p>

          <h2 class="text-h2 pb-4 pt-6">IV. Verwendung von Cookies</h2>

          <h3 class="text-h5 mb-1">1. Beschreibung und Umfang der Datenverarbeitung</h3>
          <p class="text-body-1 mb-1">
            Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die im
            Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert
            werden. Ruft ein Nutzer eine Website auf, so kann ein Cookie auf dem Betriebssystem des
            Nutzers gespeichert werden. Dieses Cookie enthält eine charakteristische Zeichenfolge,
            die eine eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website
            ermöglicht. Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten
            oder um bestimmte spezifische Funktionen der Website ausführen zu können. Einige
            Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem
            Seitenwechsel identifiziert werden kann. In den Cookies werden dabei folgende Daten
            gespeichert und übermittelt:
          </p>
          <ul class="text-body-1 mb-4">
            <li>Kontaktformular-Informationen</li>
          </ul>
          <p class="text-body-1 mb-4">
            Wir verwenden auf unserer Website darüber hinaus Cookies, die eine Analyse des
            Surfverhaltens der Nutzer ermöglichen. Zum Umfang der Datenverarbeitung durch diese
            Cookies lesen Sie bitte die weiteren Erläuterungen unter Ziffer VII. (Google Analytics).
            Beim Aufruf unserer Website werden die Nutzer durch Datenschutzbanner über die
            Verwendung von Cookies zu Analysezwecken informiert und ihre Einwilligung zur
            Verarbeitung der in diesem Zusammenhang verwendeten personenbezogenen Daten eingeholt.
            In diesem Zusammenhang erfolgt auch ein Hinweis auf diese Datenschutzerklärung und
            darauf, wie die Speicherung von Cookies in den Browsereinstellungen unterbunden werden
            kann.
          </p>

          <h3 class="text-h5 mb-1">2. Rechtsgrundlage für die Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von
            Cookies ist Art. 6 Abs. 1 lit.f DSGVO bei technisch notwendigen Cookies. Bei Cookies,
            die wir für Analysezwecke einsetzen, ist die rechtliche Grundlage Art. 6 Abs. 1 lit. a
            (Einwilligung).
          </p>

          <h3 class="text-h5 mb-1">3. Zweck der Datenverarbeitung</h3>
          <p class="text-body-1 mb-1">
            Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für
            die Nutzer zu vereinfachen. Einige Funktionen unserer Internetseite können ohne den
            Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der
            Browser auch nach einem Seitenwechsel wiedererkannt wird. Für folgende Anwendungen
            benötigen wir Cookies:
          </p>
          <ul class="text-body-1 mb-4">
            <li>Kontaktformular</li>
          </ul>
          <p class="text-body-1 mb-4">
            Die durch technisch notwendige Cookies erhobenen Nutzerdaten werden nicht zur Erstellung
            von Nutzerprofilen verwendet. Die Verwendung der Analyse-Cookies erfolgt zu dem Zweck,
            die Qualität unserer Website und ihre Inhalte zu verbessern. Durch die Analyse-Cookies
            erfahren wir, wie die Website genutzt wird und können so unser Angebot stetig
            optimieren. So wird unter Anonymisierung ihrer Daten erfasst, welche Bereiche unserer
            Internetseite und zur Verfügung gestellte Medien inhaltlich und/oder von seiner
            Gestaltung her für unsere Nutzer besonders beansprucht werden und damit für sie
            besonders interessant sind, um ein solches Angebot und seine Auffindbarkeit sowie
            Aktualisierung zu gewährleisten stetig zu verbessern. In diesen Zwecken liegt auch unser
            berechtigtes Interesse in der Verarbeitung der personenbezogenen Daten nach Art. 6 Abs.
            1 lit. f DSGVO.
          </p>
          <h3 class="text-h5 mb-1">
            4. Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit
          </h3>
          <p class="text-body-1 mb-4">
            Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unsere Seite
            übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung von
            Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie die
            Übertragung von Cookies grundsätzlich deaktivieren oder einschränken. Bereits
            gespeicherte Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert
            erfolgen. Werden Cookies für unsere Website deaktiviert, können möglicherweise nicht
            mehr alle Funktionen der Website vollumfänglich genutzt werden. Haben Sie eine
            Einwilligung zur Verarbeitung von personenbezogen Daten über Cookies gegeben, können Sie
            diese jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie die
            Cookie-Einstellungen aufrufen (hier: Link zum Datenschutzbanner) und dort Ihre Auswahl
            ändern. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten
            Verarbeitung bleibt davon unberührt.
          </p>

          <h2 class="text-h2 pb-4 pt-6">
            V. Einwilligung zur Datenübermittlung und Datenverarbeitung im Nicht EU-Ausland
          </h2>

          <h3 class="text-h5 mb-1">a) Beschreibung und Umfang der Datenverarbeitung</h3>
          <p class="text-body-1 mb-1">
            In bestimmten Fällen werden personenbezogene Daten auch an Stellen mit Sitz in Staaten
            außerhalb der EU übermittelt und dort verarbeitet, in denen europäisches
            Datenschutzrecht keine Anwendung findet oder in denen ein geringeres Datenschutzniveau
            existiert. Dies ist bei uns bei den nachfolgend dargestellten Services, die in der
            Datenschutzerklärung Einzelnen beschrieben sind, möglich:
          </p>
          <ul class="text-body-1 mb-4">
            <li>Google Analytics.</li>
          </ul>
          <p class="text-body-1 mb-4">
            Google verarbeitet Ihre Daten unter anderem auch in den Vereinigten Staaten von Amerika,
            für die die europäische Kommission gem. Art 45 Abs. 3 DSGVO mit einem
            Angemessenheitsbeschluss vom 10.7.2023 festgestellt hat, dass die Verarbeitung
            personenbezogener Daten in den USA ein dem Schutzniveau auf Grundlage der DSGVO in der
            Europäischen Union vergleichbares Schutzniveau bietet (Download Angemessenheitsbeschluss
            https://ec.europa.eu/commission/presscorner/api/files/document/print/de/ip_23_3721/IP_23_3721_DE.pdf).
          </p>
          <p class="text-body-1 mb-4">
            Da Google-Server jedoch weltweit verteilt sind kann eine Übertragung in sog. Drittländer
            (beispielsweise nach Singapur) nicht völlig ausgeschlossen werden.
          </p>
          <p class="text-body-1 mb-4">
            Eine gesetzliche oder vertragliche Genehmigung zur Übermittlung der personenbezogenen
            Daten in diese Drittländer besteht nicht. Es gibt keinen sogenannten
            Angemessenheitsbeschluss oder eine sonstige Garantie über den Umgang mit
            personenbezogenen Daten, der sicherstellt, dass Ihre Daten mit dem gleichen
            Schutzniveau, wie in Europa nach Maßgabe der DSGVO verarbeitet werden. Es besteht daher
            das Risiko, dass Ihre Daten in Drittstaaten in einer Weise verwendet werden, wie sie
            nach europäischem Recht unzulässig wäre. Dies betrifft unter anderem auch Aussagen zur
            Dauer der Speicherung, sowie Widerspruch- und Beseitigungsmöglichkeiten oder sonstige
            Rechtsmittel gegen etwaige Rechtsverletzungen durch die Nutzung Ihrer personenbezogenen
            Daten in diesen Staaten.
          </p>

          <h3 class="text-h5 mb-1">b) Rechtsgrundlage für die Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten ist insoweit –
            Übertragung in sog. Drittländer - Art. 49 I lit. a) DSDGVO (Einwilligung). Auf der
            Startseite unserer Internetseite wird Ihnen beim Aufruf der Internetseite einen
            Datenschutz-Banner angezeigt. In diesem können Sie die Datenschutzeinstellungen oder und
            Ihrer Einwilligung zur Datenübermittlung individuell konfigurieren oder alle
            Einstellungen akzeptieren. Durch einen Klick auf den entsprechenden Button billigen Sie
            ausdrücklich auch in die Übermittlung an Stellen außerhalb der EU ein, in denen die
            DSGVO keine Anwendung findet oder ein angemessenes Datenschutzniveau nicht existiert.
          </p>
          <h3 class="text-h5 mb-1">c) Zweck der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Der Zweck der Datenverarbeitung ist die die Ermittlung und Analyse von Marketingdaten
            zur Verbesserung unseres Angebots.
          </p>

          <h2 class="text-h2 pb-4 pt-6">VI. E-Mail-Kontakt und Kontaktformular</h2>

          <h3 class="text-h5 mb-1">1. Beschreibung und Umfang der Datenverarbeitung</h3>
          <p class="text-body-1 mb-1">
            Auf unserer Internetseite ist eine Kontaktaufnahme über die bereitgestellte
            E-Mail-Adresse unter dem Button „Impressum“ möglich. In diesem Fall werden die mit der
            E-Mail übermittelten personenbezogenen Daten des Nutzers gespeichert. Zusätzlich ist auf
            unserer Internetseite ein Kontaktformular vorhanden, welches für die elektronische
            Kontaktaufnahme genutzt werden kann. Nimmt der Nutzer diese Möglichkeit wahr, so werden
            die in der Eingabemaske eingegebenen Daten an uns übermittelt und gespeichert. Diese
            Daten sind:
          </p>
          <ul class="text-body-1 mb-4">
            <li>Vorname</li>
            <li>Nachname</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer</li>
          </ul>
          <p class="text-body-1 mb-1">
            Im Zeitpunkt der Absendung der Nachricht werden zusätzlich folgende Daten gespeichert:
          </p>
          <ul class="text-body-1 mb-4">
            <li>IP-Adresse des Nutzers</li>
            <li>Datum und Uhrzeit der Absendung</li>
          </ul>
          <p class="text-body-1 mb-4">
            Für die Verarbeitung der Daten wird im Rahmen des Absendevorgangs die Einwilligung des
            Nutzers eingeholt und auf diese Datenschutzerklärung verwiesen. Es erfolgt in diesem
            Zusammenhang keine Weitergabe der Daten an Dritte. Die Daten werden ausschließlich für
            die Verarbeitung der Konversation verwendet.
          </p>

          <h3 class="text-h5 mb-1">2. Rechtsgrundlage für die Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Übersendung Ihrer
            E-Mail übermittelt werden, ist Art. 6 Abs. 1 lit. f DSGVO. Zielt der E-Mail-Kontakt auf
            den Abschluss eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die
            Verarbeitung Art. 6 Abs. 1 lit. b DSGVO. Rechtsgrundlage für die Verarbeitung der Daten
            ist bei Vorliegen einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO.
          </p>

          <h3 class="text-h5 mb-1">3. Zweck der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Die Verarbeitung der personenbezogenen Daten aus der Eingabemaske des Kontaktformulars
            dient zur Bearbeitung Ihrer Kontaktaufnahme. Im Fall der Kontaktaufnahme per E-Mail
            stellt dies zugleich das erforderliche berechtigte Interesse an der Verarbeitung der
            Daten dar. Die sonstigen während des Absendevorgangs verarbeiteten personenbezogenen
            Daten dienen dazu, einen Missbrauch des Kontaktformulars zu verhindern und die
            Sicherheit unserer informationstechnischen Systeme sicherzustellen.
          </p>

          <h3 class="text-h5 mb-1">4. Dauer der Speicherung</h3>
          <p class="text-body-1 mb-4">
            Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung
            nicht mehr erforderlich sind. Für die personenbezogenen, die uns per E-Mail übersandt
            wurden sowie für diejenigen aus dem Kontaktformular, ist dies dann der Fall, wenn die
            jeweilige Konversation mit dem Nutzer beendet ist. Beendet ist die Konversation dann,
            wenn sich aus den Umständen entnehmen lässt, dass der betroffene Sachverhalt
            abschließend geklärt ist. Die während des Absendevorgangs ggf. zusätzlich erhobenen
            personenbezogenen Daten werden spätestens nach einer Frist von sieben Tagen gelöscht.
          </p>

          <h3 class="text-h5 mb-1">5. Widerspruchs- und Beseitigungsmöglichkeit</h3>
          <p class="text-body-1 mb-1">
            Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der
            personenbezogenen Daten zu widerrufen.
          </p>
          <p class="text-body-1 mb-1">
            Nimmt der Nutzer per E-Mail-Kontakt mit uns auf, so kann er der Speicherung seiner
            personenbezogenen Daten jederzeit widersprechen.
          </p>
          <p class="text-body-1 mb-1">
            Widerruf bzw. Widerspruch kann er über eine entsprechende E-Mail oder postalisch an den
            Verantwortlichen unter der in dieser Datenschutzerklärung angegebenen E-Mail-Adresse
            oder an die dort angegebene Anschrift erklären.
          </p>
          <p class="text-body-1 mb-4">
            Alle personenbezogenen Daten, die im Zuge der Kontaktaufnahme gespeichert wurden, werden
            in diesem Fall gelöscht, wenn und soweit dem nicht gesetzliche Vorschriften, z.B. nach
            dem Handelsgesetzbuch oder der Abgabenordnung, oder eine sonstige Rechtfertigung nach
            datenschutzrechtlichen Vorschriften, die eine Aufbewahrung nach Abwägung aller
            Interessen erforderlich macht, entgegensteht.
          </p>

          <h2 class="text-h2 pb-4 pt-6">VII. Webanalyse durch Google Analytics 4 (GA4)</h2>

          <h3 class="text-h5 mb-1">1. Umfang der Verarbeitung personenbezogener Daten</h3>
          <p class="text-body-1 mb-1">
            Auf unsere Website nutzen wir das Analyse-Tracking Tool Google Analytics in der Version
            4 (nachfolgend „GA“), sofern Sie Ihre Einwilligung erklärt haben. Das Tool wird von dem
            in den USA ansässigen Unternehmen Google Inc., und für den vorliegenden genutzten
            Service, Google Ireland Ltd, Gordon House Barrow Street, Dublin 4, Ireland, zur
            Verfügung gestellt („Google“). Durch GA haben wir die Möglichkeit, Ihr Surfverhalten
            über mehrere Geräte und verschiedene Plattformen (z.B. Webseiten und APP) hinweg zu
            erfassen und nachzuverfolgen sowie auszuwerten. Hierzu haben wir einen Code auf unsere
            Internetseite eingebunden, der GA ausführt, wenn Sie unsere Website aufrufen, und der
            Ihr Surfverhalten auf unserer Website erfasst und speichert.
          </p>
          <p class="text-body-1 mb-1">
            Sobald Sie unsere Website verlassen, werden erfasste Daten wie folgt an Google-Server
            übermittelt: Ihre Daten werden pseudonymisiert erfasst, indem Ihnen bei einem Besuch
            unserer Internetseite eine Nutzernummer zugeordnet wird, die in einem Cookie gespeichert
            wird, das über eine weitere ID unserem Unternehmen zugeordnet ist. Diese Nutzernummer
            kann bei einem erneuten Besuch unserer Internetseite oder anderer Internetseiten
            ausgelesen und kann als pseudonymes, wiederholtes Ereignis einer Person erfasst und
            zugeordnet werden. Sollten Sie andere Google Services nutzen, z.B. Android-
            Mobilbetriebssysteme oder ein Google-E-Mail Konto, können die Daten von Google
            gegebenenfalls Ihrer Person unmittelbar zugeordnet werden und auch eine Verknüpfung mit
            Informationen von Drittanbietern stattfinden. Dabei speichert Google die Daten auf
            verschiedenen Servern weltweit.
          </p>
          <p class="text-body-1 mb-1">
            Google erstellt aus den übermittelten Daten und aus ergänzenden Angaben oder Prognosen,
            die aus einer maschinellen Lernfunktionen von GA ermittelt werden, statistische
            Berichte, die wiederum an uns übermittelt werden. Einzelheiten der Verarbeitung durch
            Google können Sie unter https://policies.google.com/privacy?hl=de&tid=331691504557 und
            https://marketingplatform.google.com/about/analytics/terms/de/ abrufen.
          </p>
          <p class="text-body-1 mb-4">
            Durch diese Berichte erfahren wir, welche Gruppen von Personen sich für unsere Produkte.
            Leis-tungen und unsere Internetseiten interessieren, wie diese mit unserer Internetseite
            interagieren, auf welchen Wegen im Internet Sie zu unserer Internetseite gelangt sind,
            wie Sie auf Werbung reagiert haben (sog. Conversion) und mit welchem zukünftigen
            Verhalten und welchen zukünftigen Wünschen in Bezug auf unsere Produkte, Leistungen und
            unsere Internetseite zu rechnen ist.
          </p>

          <h3 class="text-h5 mb-1">2. Rechtsgrundlage der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Rechtsgrundlage für die Verarbeitung der Daten ist Ihre Einwilligung, Art. 6 Abs. 1 lit.
            a DSGVO. Weitere Rechtsgrundlage ist unser berechtigtes Interesse an der
            Datenverarbeitung durch insbesondere Erhebung statistischer Marketingdaten zur
            Optimierung und Anpassung unserer Leistungen, Produkte und Werbemaßnahmen sowie unserer
            Internetauftritte, Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h3 class="text-h5 mb-1">3. Zweck der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Die Verwendung von Google-Analytics erfolgt zu dem Zweck, die Qualität unserer Website
            und ihrer Inhalte zu verbessern. Wir erfahren, wie die Website genutzt wird und können
            so unser Angebot stetig optimieren.
          </p>

          <h3 class="text-h5 mb-1">4. Datenübermittlung in Drittstaaten ausserhalb der EU</h3>
          <p class="text-body-1 mb-4">
            Google verarbeitet Ihre Daten unter anderem auch in den Vereinigten Staaten von Amerika,
            für die die europäische Kommission gem. Art 45 Abs. 3 DSGVO mit einem
            Angemessenheitsbeschluss vom 10.7.2023 festgestellt hat, dass die Verarbeitung
            personenbezogener Daten in den USA ein dem Schutzniveau auf Grundlage der DSGVO in der
            Europäischen Union vergleichbares Schutzniveau bietet (Download Angemessenheitsbeschluss
            https://ec.europa.eu/commission/presscorner/api/files/document/print/de/ip_23_3721/IP_23_3721_DE.pdf).
          </p>

          <h3 class="text-h5 mb-1">5. Dauer der Speicherung</h3>
          <p class="text-body-1 mb-4">
            Ihre Daten werden für einen Zeitraum von 14 Monaten bei Google gespeichert. Sie werden
            nach Ablauf dieser Zeit gelöscht. Darüber hinaus werden personenbezogene Daten über Sie
            auch bei uns nicht gespeichert. Zusammengefasste Berichte, die keinen Personenbezug
            herstellen lassen, und nur allgemeine statistische Angaben wiedergeben, werden bei uns
            so lange gespeichert, wie dies für eine Marketingauswertung notwendig ist.
          </p>

          <h3 class="text-h5 mb-1">6. Widerspruchs- und Beseitigungsmöglichkeit</h3>
          <p class="text-body-1 mb-1">
            Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie
            die Cookie-Einstellungen aufrufen (hier Link zum Datenschutzbanner) und dort Ihre
            Auswahl ändern. Die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf
            erfolgten Verarbeitung bleibt davon unberührt.
          </p>
          <p class="text-body-1 mb-1">
            Sie können die Erhebung ihrer Daten durch GA darüber hinaus verhindern, indem Sie ein
            von Google hierfür zur Verfügung gestelltes Tool installieren und ausführen, das den
            GA-Service unterdrückt. Sie können dieses Tool unter
            https://tools.gogle.com/dlpage/gaoptout?hl=de herunterladen und dann installieren.
          </p>
          <p class="text-body-1 mb-4">
            Sie können auch in Ihrem jeweiligen Browser einstellen, dass auf ihrem Gerät, auf dem
            Webbrowser läuft, keine Cookies geschrieben werden sollen. Die notwendigen Funktionen
            hierfür finden Sie in der Regel im Browser in den Datenschutzeinstellungen. Dies kann
            aber je nach genutztem Browser abweichen. Bitte wenden Sie sich gegebenenfalls an den
            Anbieter Ihres Browsers, um in Erfahrung zu bringen, wie sie das Schreiben von Cookies
            auf ihrem Gerät, auf dem der jeweilige Webbrowser ausgeführt wird, verhindern können.
          </p>

          <h2 class="text-h2 pb-4 pt-6">VIII. Soziale Netzwerke</h2>

          <h3 class="text-h5 mb-1">1. Beschreibung und Umfang der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Über unsere Internetseite besteht durch Verlinkung (gekennzeichnet durch ein Piktogramm)
            auf weitere Internetseiten unserer Internet-Auftritte in sozialen Netzwerken die
            Möglichkeit, unsere jeweilige Internetseite in diesen sozialen Netzwerken aufzurufen.
            Diese sind:
          </p>
          <p class="text-body-1 mb-4">
            LinkedIn: <br />
            LinkedIn Ireland Unlimited Company ist ein soziales Netzwerk zur Pflege bestehender
            Geschäftskontakte mit Sitz in Wilton Plaza, Wilton Place, Dublin 2, Irland. In LinkedIn
            haben wir unsere Unternehmensinternetseite integriert.<br />
            a) Durch die Betätigung des Links (Hyperlink) auf unserer Internetseite, die auf die
            Internetseite des jeweiligen sozialen Netzwerks referenzieren, rufen Sie die
            Internetseite des Betreibers des Sozialen Netzwerks auf. Gegebenenfalls müssen Sie sich
            zum vollständigen Abruf unseres Internet-Auftritts auf der Internetseite des jeweiligen
            Sozialen Netzwerks in Ihr Kundenkonto des Sozialen Netzwerks einloggen. Wir erhalten
            dann gegebenenfalls Zugriff auf Ihre öffentlichen Informationen auf dem Sozialen
            Netzwerk oder solche, die Sie für die jeweilige Anwendung innerhalb des sozialen
            Netzwerks freigeben. Die öffentlichen Informationen kann jeder Dritte einsehen. Solche
            Information sind insbesondere Ihr Name, ihr Profil, Titelbilder und Fotografien,
            Geschlecht, Netzwerke, Nutzername und Nutzerkennung), Kommentare und Beiträge
            (Nutzerinhalte). Dabei kann es entsprechend vertraglicher Vereinbarungen zwischen den
            Betreibern der jeweiligen sozialen Netzwerke auch zu einem Informationsaustausch
            zwischen diesen Netzwerken kommen. Über Einzelheiten zu personenbezogenen Daten, die
            innerhalb des sozialen Netzwerks verarbeitet werden, entscheidet Ihre vertragliche
            Beziehung zum Betreiber des Sozialen Netzwerks und dessen jeweilige
            Datenschutzbestimmung und Datenschutzregularien, auf die insoweit verwiesen wird. Diese
            sind auf der Internetseite des sozialen Netzwerks abrufbar. Sie werden auch von uns nur
            innerhalb des sozialen Netzwerks im Rahmen der dort jeweils gebotenen Funktionen und
            Verfahren genutzt und verarbeitet. Personenbezogene Daten, die wir innerhalb unseres
            Internet-Auftritts in dem sozialen Netzwerk nutzen, werden nicht von uns an dritte
            Stellen übermittelt, wenn und soweit vorliegend nicht ausdrücklich etwas anderes
            geregelt ist oder eine Einwilligung ihrerseits in eine solche Übermittlung vorliegt.
            Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des
            Nutzers Art. 6 Abs. 1 lit. a), andernfalls Art. 6 Abs. lit f) DSGVO.
          </p>

          <h3 class="text-h5 mb-1">2. Zweck der Datenverarbeitung</h3>
          <p class="text-body-1 mb-4">
            Ihre personenbezogenen Daten verwenden wir ausschließlich zu dem Zweck, diese dem
            jeweiligen Dienst im sozialen Netzwerk anzubieten und zur Verfügung zu stellen. Eine
            weitergehende Verwendung erfolgt allenfalls, wenn Ihre rechtswirksame Einwilligung
            vorliegt oder wir hierzu gesetzlich verpflichtet sind.
          </p>
          <h3 class="text-h5 mb-1">3. Dauer der Speicherung</h3>
          <p class="text-body-1 mb-4">
            Die Speicherung erfolgt für die Dauer der Verknüpfung ihrer Daten mit unserer
            Internetseite im sozialen Netzwerk und für die Dauer des Bestands unserer Internetseite
            im sozialen Netzwerk.
          </p>
          <h3 class="text-h5 mb-1">4. Widerspruchs- und Beseitigungsmöglichkeit</h3>
          <p class="text-body-1 mb-4">
            Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der
            personenbezogenen Daten zu widerrufen bzw. der Verarbeitung der personenbezogenen Daten
            zu widersprechen. Widerruf bzw. Widerspruch kann er über eine entsprechende E-Mail oder
            postalisch an den Verantwortlichen unter der in dieser Datenschutzerklärung angegebenen
            E-Mail-Adresse oder an die dort angegebene Anschrift erklären. Alle personenbezogenen
            Daten, die im Zuge der Nutzung unserer Dienste in sozialen Netzwerken von uns
            gespeichert wurden, werden in diesem Fall gelöscht, soweit datenschutzrechtliche
            Regelungen, die eine gesetzliche oder entsprechend dem Vertragszweck notwendige
            Aufbewahrung der jeweiligen Daten erforderlich machen, nicht entgegenstehen. Sie können
            durch Einstellungen innerhalb ihres Social Media-Account auch eine Verknüpfung ihrer
            Daten mit unserem Internetdienst aufheben oder einschränken.
          </p>

          <h2 class="text-h2 pb-4 pt-6">IX. Rechte der betroffenen Person</h2>
          <p class="text-body-1 mb-4">
            Werden personenbezogene Daten von Ihnen durch uns verarbeitet, sind Sie Betroffener
            i.S.d. DSGVO und es stehen Ihnen folgende Rechte gegenüber dem Verantwortlichen zu:
          </p>

          <h3 class="text-h5 mb-1">1. Auskunftsrecht</h3>
          <p class="text-body-1 mb-4">
            Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob
            personenbezogene Daten, die Sie betreffen, von uns verarbeitet werden. Liegt eine solche
            Verarbeitung vor, können Sie von dem Verantwortlichen über folgende Informationen
            Auskunft verlangen:<br />
            (1) die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden;<br />
            (2) die Kategorien von personenbezogenen Daten, welche verarbeitet werden;<br />
            (3) die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die Sie
            betreffenden personenbezogenen Daten offengelegt wurden oder noch offengelegt werden;<br />
            (4) die geplante Dauer der Speicherung der Sie betreffenden personenbezogenen Daten
            oder, falls konkrete Angaben hierzu nicht möglich sind, Kriterien für die Festlegung der
            Speicherdauer;<br />
            (5) das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden
            personenbezogenen Daten, eines Rechts auf Einschränkung der Verarbeitung durch den
            Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung;<br />
            (6) das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;<br />
            (7) alle verfügbaren Informationen über die Herkunft der Daten, wenn die
            personenbezogenen Daten nicht bei der betroffenen Person erhoben werden;<br />
            (8) das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling
            gemäß Art. 22 Abs. 1 und 4 DSGVO und – zumindest in diesen Fällen – aussagekräftige
            Informationen über die involvierte Logik sowie die Tragweite und die angestrebten
            Auswirkungen einer derartigen Verarbeitung für die betroffene Person. Ihnen steht das
            Recht zu, Auskunft darüber zu verlangen, ob die Sie betreffenden personenbezogenen Daten
            in ein Drittland oder an eine internationale Organisation übermittelt werden. In diesem
            Zusammenhang können Sie verlangen, über die geeigneten Garantien gem. Art. 46 DSGVO im
            Zusammenhang mit der Übermittlung unterrichtet zu werden.
          </p>

          <h3 class="text-h5 mb-1">2. Recht auf Berichtigung</h3>
          <p class="text-body-1 mb-4">
            Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem
            Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen,
            unrichtig oder unvollständig sind. Der Verantwortliche hat die Berichtigung unverzüglich
            vorzunehmen.
          </p>
          <h3 class="text-h5 mb-1">3. Recht auf Einschränkung der Verarbeitung</h3>
          <p class="text-body-1 mb-4">
            Unter den folgenden Voraussetzungen können Sie die Einschränkung der Verarbeitung der
            Sie betreffenden personenbezogenen Daten verlangen:<br />
            (1) wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine Dauer
            bestreiten, die es dem Verantwortlichen ermöglicht, die Richtigkeit der
            personenbezogenen Daten zu überprüfen;<br />
            (2) die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten
            ablehnen und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten
            verlangen;<br />
            (3) der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung
            nicht länger benötigt, Sie diese jedoch zur Geltendmachung, Ausübung oder Verteidigung
            von Rechtsansprüchen benötigen, oder<br />
            (4) wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO eingelegt
            haben und noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen
            gegenüber Ihren Gründen überwiegen. Wurde die Verarbeitung der Sie betreffenden
            personenbezogenen Daten eingeschränkt, dürfen diese Daten – von ihrer Speicherung
            abgesehen – nur mit Ihrer Einwilligung oder zur Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen
            oder juristischen Person oder aus Gründen eines wichtigen öffentlichen Interesses der
            Union oder eines Mitgliedstaats verarbeitet werden. Wurde die Einschränkung der
            Verarbeitung nach den o.g. Voraussetzungen eingeschränkt, werden Sie von dem
            Verantwortlichen unterrichtet bevor die Einschränkung aufgehoben wird.
          </p>
          <h3 class="text-h5 mb-1">4. Recht auf Löschung</h3>
          <p class="text-body-1 mb-4">
            a) Löschungspflicht Sie können von dem Verantwortlichen verlangen, dass die Sie
            betreffenden personenbezogenen Daten unverzüglich gelöscht werden, und der
            Verantwortliche ist verpflichtet, diese Daten unverzüglich zu löschen, sofern einer der
            folgenden Gründe zutrifft: (1) Die Sie betreffenden personenbezogenen Daten sind für die
            Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr
            notwendig.<br />
            (2) Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem. Art. 6 Abs. 1
            lit. a oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es fehlt an einer anderweitigen
            Rechtsgrundlage für die Verarbeitung.<br />
            (3) Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und es
            liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen
            gem. Art. 21 Abs. 2 DSGVO Widerspruch gegen die Verarbeitung ein.<br />
            (4) Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet.<br />
            (5) Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung einer
            rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten
            erforderlich, dem der Verantwortliche unterliegt.<br />
            (6) Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene Dienste
            der Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben. <br /><br />

            b) Information an Dritte Hat der Verantwortliche die Sie betreffenden personenbezogenen
            Daten öffentlich gemacht und ist er gem. Art. 17 Abs. 1 DSGVO zu deren Löschung
            verpflichtet, so trifft er unter Berücksichtigung der verfügbaren Technologie und der
            Implementierungskosten angemessene Maßnahmen, auch technischer Art, um für die
            Datenverarbeitung Verantwortliche, die die personenbezogenen Daten verarbeiten, darüber
            zu informieren, dass Sie als betroffene Person von ihnen die Löschung aller Links zu
            diesen personenbezogenen Daten oder von Kopien oder Replikationen dieser
            personenbezogenen Daten verlangt haben.<br /><br />
            c) Ausnahmen Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich
            ist<br />
            (1) zur Ausübung des Rechts auf freie Meinungsäußerung und Information;<br />
            (2) zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht
            der Union oder der Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert, oder
            zur Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt oder in Ausübung
            öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde;<br />
            (3) aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit gemäß
            Art. 9 Abs. 2 lit. h und i sowie Art. 9 Abs. 3 DSGVO;<br />
            (4) für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder
            historische Forschungszwecke oder für statistische Zwecke gem. Art. 89 Abs. 1 DSGVO,
            soweit das unter Abschnitt a) genannte Recht voraussichtlich die Verwirklichung der
            Ziele dieser Verarbeitung unmöglich macht oder ernsthaft beeinträchtigt, oder<br />
            (5) zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
          </p>
          <h3 class="text-h5 mb-1">5. Recht auf Unterrichtung</h3>
          <p class="text-body-1 mb-4">
            Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung
            gegenüber dem Verantwortlichen geltend gemacht, ist dieser verpflichtet, allen
            Empfängern, denen die Sie betreffenden personenbezogenen Daten offengelegt wurden, diese
            Berichtigung oder Löschung der Daten oder Einschränkung der Verarbeitung mitzuteilen, es
            sei denn, dies erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand
            verbunden. Ihnen steht gegenüber dem Verantwortlichen das Recht zu, über diese Empfänger
            unterrichtet zu werden.
          </p>
          <h3 class="text-h5 mb-1">6. Recht auf Datenübertragbarkeit</h3>
          <p class="text-body-1 mb-4">
            Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie dem
            Verantwortlichen bereitgestellt haben, in einem strukturierten, gängigen und
            maschinenlesbaren Format zu erhalten. Außerdem haben Sie das Recht diese Daten einem
            anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die
            personenbezogenen Daten bereitgestellt wurden, zu übermitteln, sofern<br />
            (1) die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO oder Art. 9
            Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b DSGVO beruht und<br />
            (2) die Verarbeitung mithilfe automatisierter Verfahren erfolgt. In Ausübung dieses
            Rechts haben Sie ferner das Recht, zu erwirken, dass die Sie betreffenden
            personenbezogenen Daten direkt von einem Verantwortlichen einem anderen Verantwortlichen
            übermittelt werden, soweit dies technisch machbar ist. Freiheiten und Rechte anderer
            Personen dürfen hierdurch nicht beeinträchtigt werden. Das Recht auf
            Datenübertragbarkeit gilt nicht für eine Verarbeitung personenbezogener Daten, die für
            die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder
            in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde.
          </p>
          <h3 class="text-h5 mb-1">7. Widerspruchsrecht</h3>
          <p class="text-body-1 mb-4">
            Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben,
            jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die
            aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies
            gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Der Verantwortliche
            verarbeitet die Sie betreffenden personenbezogenen Daten nicht mehr, es sei denn, er
            kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre
            Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der
            Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen. Werden die Sie
            betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, haben
            Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden
            personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das
            Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Widersprechen Sie
            der Verarbeitung für Zwecke der Direktwerbung, so werden die Sie betreffenden
            personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet. Sie haben die
            Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft –
            ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht mittels automatisierter
            Verfahren auszuüben, bei denen technische Spezifikationen verwendet werden.
          </p>

          <h3 class="text-h5 mb-1">
            8. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung
          </h3>
          <p class="text-body-1 mb-4">
            Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu
            widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der
            Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
          </p>

          <h3 class="text-h5 mb-1">
            9. Automatisierte Entscheidung im Einzelfall einschließlich Profiling
          </h3>
          <p class="text-body-1 mb-4">
            Sie haben das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung –
            einschließlich Profiling – beruhenden Entscheidung unterworfen zu werden, die Ihnen
            gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich
            beeinträchtigt. Dies gilt nicht, wenn die Entscheidung<br />
            (1) für den Abschluss oder die Erfüllung eines Vertrags zwischen Ihnen und dem
            Verantwortlichen erforderlich ist,<br />
            (2) aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der
            Verantwortliche unterliegt, zulässig ist und diese Rechtsvorschriften angemessene
            Maßnahmen zur Wahrung Ihrer Rechte und Freiheiten sowie Ihrer berechtigten Interessen
            enthalten oder<br />
            (3) mit Ihrer ausdrücklichen Einwilligung erfolgt. Allerdings dürfen diese
            Entscheidungen nicht auf besonderen Kategorien personenbezogener Daten nach Art. 9 Abs.
            1 DSGVO beruhen, sofern nicht Art. 9 Abs. 2 lit. a oder g DSGVO gilt und angemessene
            Maßnahmen zum Schutz der Rechte und Freiheiten sowie Ihrer berechtigten Interessen
            getroffen wurden. Hinsichtlich der in (1) und (3) genannten Fälle trifft der
            Verantwortliche angemessene Maßnahmen, um die Rechte und Freiheiten sowie Ihre
            berechtigten Interessen zu wahren, wozu mindestens das Recht auf Erwirkung des
            Eingreifens einer Person seitens des Verantwortlichen, auf Darlegung des eigenen
            Standpunkts und auf Anfechtung der Entscheidung gehört.
          </p>
          <h3 class="text-h5 mb-1">10. Recht auf Beschwerde bei einer Aufsichtsbehörde</h3>
          <p class="text-body-1 mb-4">
            Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
            steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
            Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen
            Verstoßes, zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
            personenbezogenen Daten gegen die DSGVO verstößt. Die Aufsichtsbehörde, bei der die
            Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die
            Ergebnisse der Beschwerde einschließlich der Möglichkeit eines gerichtlichen
            Rechtsbehelfs nach Art. 78 DSGVO.
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<style scoped lang="scss">
ul {
  list-style: none;
  margin-left: 0;
  padding-left: 0;
}

li {
  padding-left: 1em;

  &:before {
    content: '-';
    display: inline-block;
    width: 1.3em;
    margin-left: -1em;
  }
}
</style>
